 <template>
	<div class="loading_container">
		磊
	</div>
</template>

<script>
    export default {
    	data(){
        return{
          positionY: 0,
          timer: null,
        }
      },
        mounted(){
        	this.timer = setInterval(() => {
        		this.positionY ++;
        	}, 600)
        },
        beforeDestroy(){
        	clearInterval(this.timer);
        }
    }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/mixin';
</style>



// WEBPACK FOOTER //
// loading.vue?d04a9d88